import * as React from 'react';
import { Navigate } from 'react-router-dom';

// import useAuth from '../../hooks/useAuth';
import { AuthUser, UserRole } from '../../types/auth';

interface GuestGuardType {
  children: React.ReactNode;
} 

// For routes that can only be accessed by unauthenticated users
function GuestGuard({ children }: GuestGuardType) {
  // const { isAuthenticated, isInitialized } = useAuth();

  const userSession = localStorage.getItem('user');

  if (userSession) {
    const localUser = localStorage.getItem('user');
    const userLocalStorage = localUser ? (JSON.parse(localUser) as AuthUser) : null;
    const role = userLocalStorage?.role?.role;

    if (role === UserRole.EMPLOYEE) {
      return <Navigate to="/employee" />;
    }

    return <Navigate to="/dashboard" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default GuestGuard;
